// Investigation for manual enrolment

import {
    PasskeyFlowState,
    PASSKEY_FLOW_RESET,
    PASSKEY_ENROLLMENT_STARTED,
    PASSKEY_ENROLLMENT_SUCCEEDED,
    PASSKEY_ENROLLMENT_FAILED,
    PASSKEY_ENROLLMENT_UNSUPPORTED
} from "../../domain/passkeyFlow/index";

export const initialState: PasskeyFlowState = {
    status: "idle",
    errorCode: null
};

// The explicit return type matters: without it TypeScript widens `status` to
// `string`, which no longer satisfies `PasskeyFlowState` and breaks the
// inferred type of the combined root reducer in `Common/reducers`.
export default function passkeyFlow(state = initialState, action: any): PasskeyFlowState {
    switch (action.type) {
        case PASSKEY_FLOW_RESET:
            return initialState;
        case PASSKEY_ENROLLMENT_STARTED:
            // Clear any previous error so a retry starts from a clean slate.
            return { ...state, status: "working", errorCode: null };
        case PASSKEY_ENROLLMENT_SUCCEEDED:
            return { ...state, status: "enrolled", errorCode: null };
        case PASSKEY_ENROLLMENT_FAILED:
            return { ...state, status: "error", errorCode: action.payload };
        case PASSKEY_ENROLLMENT_UNSUPPORTED:
            return { ...state, status: "unsupported", errorCode: null };
        default:
            return state;
    }
}
